<div class="profile-avatar">
  @if (imageUrl) {
    <img [src]="imageUrl" class="avatar-image" alt="" />
  } @else {
    <span class="initials">{{ initials }}</span>
  }
</div>
